import Image from 'next/image'
import styled from 'styled-components'
import heartsImage from '../../../assets/homepage-v2/hearts.png'

const SectionWrapper = styled.section`
  width: 100%;
  margin: 0 auto;
  padding: 40px 20px 80px;
  display: flex;
  flex-direction: column;
  align-items: center;
  
  @media (max-width: 768px) {
    box-sizing: border-box;
    padding: 20px 20px 40px;
  }
`

const ReviewsContainer = styled.div`
  display: flex;
  gap: 20px;
  width: 100%;
  justify-content: center;
  flex-wrap: wrap;

  @media (max-width: 1024px) {
    flex-direction: column;
    align-items: center;
  }
`

const ReviewCard = styled.div`
  width: ${props => props.wide ? '516px' : '323px'};
  height: auto;
  border-radius: 20px;
  padding: 23px 22px;
  display: flex;
  flex-direction: column;
  gap: 10px;
  position: relative;
  overflow: hidden;
  
  @media (max-width: 768px) {
    box-sizing: border-box;
    width: 100%;
    max-width: 100%;
    min-height: 250px;
  }
`

const OrangeCard = styled(ReviewCard)`
  background: linear-gradient(180deg, #ff340b 0%, #ff7525 62%, #ffd280 100%);
`

const BlueCard = styled(ReviewCard)`
  background: linear-gradient(180deg, #0037ff 0%, #008ccd 63%, #71e5f5 100%);
`

const PinkCard = styled(ReviewCard)`
  background: linear-gradient(180deg, #ffafaf 0%, #f08e8e 100%);
`

const StarsContainer = styled.div`
  display: flex;
  gap: 4px;
`

const Star = styled.div`
  width: 15px;
  height: 13px;
  background: white;
  clip-path: polygon(50% 0%, 61% 35%, 98% 35%, 68% 57%, 79% 91%, 50% 70%, 21% 91%, 32% 57%, 2% 35%, 39% 35%);
`

const ReviewTitle = styled.h3`
  color: white;
  font-size: 32px;
  font-weight: 500;
  margin: 0;

  @media (max-width: 768px) {
    font-size: 20px;
  }
`

const ReviewText = styled.p`
  color: white;
  font-size: 18px;
  font-weight: 400;
  margin: 0;
  line-height: 1.5;

  @media (max-width: 768px) {
    font-size: 14px;
  }
`

const ReviewAuthor = styled.span`
  color: white;
  font-size: 18px;
  font-weight: 700;
`

const HeartsDecoration = styled.div`
  position: absolute;
  right: 24px;
  bottom: 30px;
  filter: drop-shadow(0px 4px 4px rgba(255, 65, 65, 0.36));

  @media (max-width: 768px) {
    right: 16px;
    bottom: 18px;

    img {
      width: 58px !important;
      height: 41px !important;
    }
  }
`

const reviews = [
  {
    type: 'orange',
    title: 'Therapy app!',
    text: "I've been a member since April 2021, and DecorMatters is my favorite \"therapy\" app and house design game. I love being creative, seeing beautiful designs, and being part of an encouraging community of interior decorators. It's truly my go-to interior design app when I want to relax and feel inspired.",
    author: '@coola'
  },
  {
    type: 'blue',
    title: 'Super Enjoyable Design Game',
    text: "I've been playing DecorMatters for over 3 years, and it continues to get better with high-quality decor items and fun design challenges. This home design game is my go-to when I want to relax, be creative, and let my ideas flow. I've also made friends in the community, which makes it even more enjoyable.",
    author: '@ravenrosey'
  },
  {
    type: 'pink',
    wide: true,
    title: 'Best design app!',
    text: "This is the only true-to-scale design app that lets you actually design your dream home. With DecorMatters, you are truly the designer and room planner - whether you're completing design challenges or uploading your own real space. You can use their large library of high-quality furniture or upload your own art, decor, flowers, wallpapers, windows, and more. I hesitate to even call it a game, because it's so much more than that. The freedom to design real rooms is unmatched, and the yearly subscription is very affordable compared to other home design apps. My only complaint is that I can spend hours on it without realizing how much time has passed - it just keeps getting better every year.",
    author: '@NioakaBayos'
  }
]

const ReviewsSection = () => {
  const renderCard = (review, index) => {
    const CardComponent = review.type === 'orange' ? OrangeCard : review.type === 'blue' ? BlueCard : PinkCard

    return (
      <CardComponent key={index} wide={review.wide}>
        <StarsContainer>
          {[...Array(5)].map((_, i) => (
            <Star key={i} />
          ))}
        </StarsContainer>
        <ReviewTitle>{review.title}</ReviewTitle>
        <ReviewText>{review.text}</ReviewText>
        <ReviewAuthor>{review.author}</ReviewAuthor>
        {review.type === 'orange' && (
          <HeartsDecoration>
            <Image src={heartsImage} alt="" width={71} height={50} />
          </HeartsDecoration>
        )}
      </CardComponent>
    )
  }

  return (
    <SectionWrapper>
      <ReviewsContainer>
        {reviews.map((review, index) => renderCard(review, index))}
      </ReviewsContainer>
    </SectionWrapper>
  )
}

export default ReviewsSection
